import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urlCoverSizeFormat'
})
export class UrlCoverSizeFormatPipe implements PipeTransform {

  transform(value: string): unknown {
    const pretraitement = value.slice(value.indexOf('fit-in')).slice(7);
    return pretraitement.slice(0, pretraitement.indexOf('/'));
  }

}
